import { ListBox, Table } from '@flos/react-ui';
import { useRecoilValue } from 'recoil';
import { accountHolderAtom } from '../../../recoil/atoms/accountHolderAtom';
import { useHippoText } from '../../../hooks/useHippoText';
import { additionalNameInsuredAtom } from '../../../recoil/atoms/additionalNameInsuredAtom';
import useWindowSize from '../../../hooks/useWindowSize';

const CoverableDetailsGeneralInformation = (): React.JSX.Element => {
    const accountHolderData = useRecoilValue(accountHolderAtom);
    const additionalNameInsuredData = useRecoilValue(additionalNameInsuredAtom);
    const getHippoText = useHippoText();
    const singleInsuranceHolderText = getHippoText('DSS-COVERABLE-DETAILS-POLICY-HOLDER');
    const multipleInsuranceHolderText = getHippoText('DSS-COVERABLE-DETAILS-POLICY-HOLDERS');
    const { isMobileDevice } = useWindowSize();
    const listBoxIsOpen = !isMobileDevice;
    const accountHolderName =
        (accountHolderData.firstName ?? '') + ' ' + (accountHolderData.lastName ?? '');
    const additionalPolicyHolderNames = additionalNameInsuredData
        .map((additionalNameInsured) => {
            return additionalNameInsured.displayName;
        })
        .filter((name) => name);
    return (
        <div className="u-spacing-inset-m--stretch-max">
            <ListBox
                title={getHippoText('DSS-COVERABLE-DETAILS-GENERAL-INFORMATION')}
                isOpen={listBoxIsOpen}
            >
                <Table>
                    <Table.Body>
                        <Table.Row>
                            <Table.Cell>
                                <span className="u-Normalwrap">
                                    {additionalNameInsuredData.length === 0
                                        ? singleInsuranceHolderText
                                        : multipleInsuranceHolderText}
                                </span>
                            </Table.Cell>
                            <Table.Cell align="right">
                                <span className="u-Normalwrap">
                                    {accountHolderName}
                                    {additionalPolicyHolderNames.map((name) => {
                                        return <div key={name}>{name}</div>;
                                    })}
                                </span>
                            </Table.Cell>
                        </Table.Row>
                        <Table.Row>
                            <Table.Cell>
                                <span className="u-Normalwrap">
                                    {getHippoText('DSS-COVERABLE-DETAILS-PAYMENT-RESPONSIBLE')}
                                </span>
                            </Table.Cell>
                            <Table.Cell align="right">
                                <span className="u-Normalwrap"> {accountHolderName} </span>
                            </Table.Cell>
                        </Table.Row>
                    </Table.Body>
                </Table>
            </ListBox>
        </div>
    );
};

export default CoverableDetailsGeneralInformation;
